import { render, staticRenderFns } from "./mobileAd.vue?vue&type=template&id=6c851eae"
import script from "./mobileAd.vue?vue&type=script&lang=js"
export * from "./mobileAd.vue?vue&type=script&lang=js"
import style0 from "./mobileAd.vue?vue&type=style&index=0&id=6c851eae&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports